<template>
    <div className="bg-primary text-primary-foreground pt-16 pb-8 border-t border-primary/10" style="color: #c7c7c7;">
        <div class="container mx-auto px-4">
            <div class="grid md:grid-cols-4 gap-12 mb-12">

                <!-- Brand -->
                <div class="md:col-span-2 space-y-4">
                    <RouterLink to="/" class="inline-block">
                        <h3 class="text-2xl font-serif font-normal tracking-tight">
                            ArtPulse
                        </h3>
                        <p class="text-xs uppercase tracking-[0.2em] text-primary-foreground/60">
                            by Shruti
                        </p>
                    </RouterLink>

                    <p class="text-primary-foreground/70 max-w-sm leading-relaxed">
                        Celebrating the beauty of life through colors, strokes, and imagination.
                        Original paintings, prints, and workshops for art lovers.
                    </p>
                </div>

                <!-- Links -->
                <div>
                    <h4 class="font-serif text-lg mb-6">Explore</h4>
                    <ul class="space-y-3">
                        <li>
                            <RouterLink to="/gallery" class="footer-link">Gallery</RouterLink>
                        </li>
                        <li>
                            <RouterLink to="/commission" class="footer-link">Commissions</RouterLink>
                        </li>
                        <!-- <li>
                            <RouterLink to="/workshops" class="footer-link">Workshops</RouterLink>
                        </li> -->
                        <li>
                            <RouterLink to="/about" class="footer-link">About</RouterLink>
                        </li>
                        <li>
                            <RouterLink to="/contact" class="footer-link">Contact</RouterLink>
                        </li>
                    </ul>
                </div>

                <!-- Social -->
                <div>
                    <h4 class="font-serif text-lg mb-6">Connect</h4>
                    <div class="flex gap-4 mb-6">
                        <a href="https://www.instagram.com/artpulse_by_shruti/" target="_blank" class="social-btn"
                            aria-label="Instagram">
                            <i class="fa-brands fa-instagram"></i>
                             <!-- <Instagram :size="20" /> -->
                        </a>

                        <a href="https://www.youtube.com/@artpulse_by_shruti" target="_blank" class="social-btn"
                            aria-label="YouTube">
                            <i class="fa-brands fa-youtube"></i>
                            <!-- <Youtube :size="20" /> -->
                        </a>

                        <a href="mailto:artpulsebyshruti@gmail.com" class="social-btn" aria-label="Email">
                            <i class="fa-regular fa-envelope"></i>
                            <!-- <Mail :size="20" /> -->
                        </a>
                    </div>

                    <p class="text-sm text-primary-foreground/50">
                        Phoenix Arizona, USA
                    </p>
                </div>
            </div>

            <!-- Bottom -->
            <div
                class="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-primary-foreground/40">
                <p>© {{ currentYear }} ArtPulse by Shruti. All rights reserved.</p>
                <div class="flex gap-6">
                    <a href="#" class="hover:text-primary-foreground/60 transition-colors">Privacy Policy</a>
                    <a href="#" class="hover:text-primary-foreground/60 transition-colors">Terms of Service</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import { Instagram, Youtube, Mail } from 'lucide-vue-next'

export default {
    name: 'FooterPage',

    //   components: {
    //     Instagram,
    //     Youtube,
    //     Mail,
    //   },

    data() {
        return {
            currentYear: new Date().getFullYear(),
        }
    },
}
</script>

<style scoped>
.footer-link {
  @apply text-gray-400 hover:text-white transition-colors;
}

.social-btn {
    @apply bg-white/10 rounded-full hover:bg-white/20 transition-colors;
       font-size: 19px;
    padding: 4px 10px;

}
p {
    margin-top: 0px ;
}
</style>
